const LABELS = {
  US: 'United States',
  UK: 'United Kingdom',
  EU: 'Europe',
  CN: 'China',
};

const processSizeChartFunc = () => {
  const drawer = document.getElementById('#KiwiSizingChart');
  const root = drawer || document;

  const ksConversionSelectElem = root.querySelector('.ks-i18n-conversion') || document.querySelector('.ks-i18n-conversion');

  if (!ksConversionSelectElem) return;

  if (ksConversionSelectElem.dataset.processed) return;
  ksConversionSelectElem.dataset.processed = '1';

  let countryNameElem = ksConversionSelectElem.parentElement.querySelector('span');
  if (!countryNameElem) {
    countryNameElem = document.createElement('span');
    ksConversionSelectElem.parentElement.append(countryNameElem);
  }

  const sync = () => {
    countryNameElem.textContent = ksConversionSelectElem.value || '';
  };

  for (const option of ksConversionSelectElem.options) {
    const label = LABELS[option.value];
    if (label) option.textContent = label;
  }

  sync();
  ksConversionSelectElem.addEventListener('change', sync, { passive: true });
};

document.addEventListener('click', (e) => {
  const opener = e.target.closest('.size-guide-opener');
  if (!opener) return;

  processSizeChartFunc();
});
